import type { AxiosRequestConfig } from 'axios';

/** autoCancel 取消请求时抛出的错误信息，响应拦截器与 isRequestCanceled 共用 */
export const REQUEST_CANCELED_MESSAGE = '💩💩💩请求已取消';

/** 是否为 autoCancel 主动取消的请求（axios 的 ERR_CANCELED 会被响应拦截器包装为普通 Error） */
export const isRequestCanceled = (err: unknown) => err instanceof Error && err.message === REQUEST_CANCELED_MESSAGE;

export const generateCustomRequestKey = () => '' + Date.now() + Math.random();

export const generateURL = (config: AxiosRequestConfig) =>
    config && [config.method, config.url?.replace(import.meta.env.VITE_APP_API_URL, ''), config.customRequestKey].filter(Boolean).join('&');
